import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-checkout-phonenumber-summary-price-details',
    templateUrl: './checkout-phonenumber-summary-price-details.component.html',
    styleUrls: [],
    standalone: false
})
export class CheckoutPhonenumberSummaryPriceDetailsComponent implements OnInit {

  @Input() summaryPrice: number;
  @Input() totalLabel = 'checkout_summary_total';

  constructor() {
  }

  ngOnInit() {
  }

  getCalculatedVat() {
    return this.summaryPrice * 0.19;
  }

  getCalculatedSummary() {
    return this.getCalculatedVat() + this.summaryPrice;
  }
}
